// extracted by mini-css-extract-plugin
module.exports = {"employeeSalary":"Item_employeeSalary_1T8fO"};